import api from '../api'

export default {
    namespaced: true,
    state: {
        manualRechargeUserChipsList: {
            beanList: [],
            total: 0
        },
        totalAbsRechargeChip: 0
    },
    mutations: {
        setStateManualRechargeUserChipsList(state, info) {
            state.manualRechargeUserChipsList = info
        },
        setStateTotalAbsRechargeChip(state,info){
            state.totalAbsRechargeChip = info.totalAbsRechargeChip
        }
    },
    actions: {
        getUserInfo(store, params) {
            return api.post('/manualRechargeUserChips/userInfo', '用户信息', params)
        },
        doManualRecharge(store, params) {
            return api.post('/manualRechargeUserChips/doManualRecharge', '手动充豆', params)
        },
        doBatchManualRecharge(store, params) {
            return api.post('/manualRechargeUserChips/doBatchManualRecharge', '批量手动充豆', params)
        },
        getManualRechargeUserChipsList({commit,dispatch}, params) {
            return api.post('/manualRechargeUserChips/list', '充豆记录列表', params).then(res => {
                commit('setStateManualRechargeUserChipsList', res.data);
                dispatch('getManualRechargeUserChipsSum',params)
            })
        },
        getManualRechargeUserChipsSum({commit}, params) {
            return api.post('/manualRechargeUserChips/sum', '充豆统计', params).then(res => {
                commit('setStateTotalAbsRechargeChip', res.data)
            })
        },
        updateRechargeStatus(store, params) {
            return api.post('/manualRechargeUserChips/updateRechargeStatus', '更新充豆状态', params)
        },
    }
}